import type {HeaderData} from '@commercial-website/data-layer'

const header: HeaderData = {
    ctaButtonText: 'Get Started',
    logInText: 'Log in',
    noResultsText: 'No results found',
    // The legacy Header unconditionally rendered a 'Book a demo' link for all secondary
    // locales, using an absolute /ie/demo path with a country query param (genericBookADemo
    // behavior in header-nav-right.tsx pre-HeaderV2 migration) - preserved here as the
    // secondary CTA so HeaderV2 keeps showing it.
    secondaryCtaText: 'Book a demo',
    secondaryCtaHref: '/ie/demo?country=at',
    items: [
        {
            label: 'Pricing',
            href: '/at/pricing',
            hideOn: 'tablet',
        },
        {
            label: 'Pricing Plans',
            hideOn: 'all',
            groups: [
                {
                    label: 'Pricing',
                    links: [{text: 'Pricing Plans', href: '/at/pricing'}],
                },
            ],
        },
    ],
}

export default header
